'use client';

import React, { useEffect } from 'react';
import { MedScoutMapsProvider } from 'src/components/Maps/MedScoutMapsProvider';

import { MapProvider } from 'src/context/map';
import { DiscoveryMap } from 'src/components';
import { LOCATION } from 'src/hooks/filters/constants';
import {
  useAppDispatch,
  useAppSelector,
  activateLocation,
  selectFilterSetsHydrated,
} from 'src/redux';
import { ResultsListProvider } from './components/ResultsPanel/context/ResultsListProvider';

const Discovery = () => {
  const dispatch = useAppDispatch();
  const isHydrated = useAppSelector(selectFilterSetsHydrated);

  // Filter state is one global object swapped per location by `activateLocation`.
  // Discovery never activated its own location, so it inherited whatever the
  // last-opened drawer (Territory Analytics, table volume) left behind —
  // showing a filter count for filters Discovery can neither render nor clear
  // (PTRI-235). Activate on mount, once hydration has restored saved state.
  useEffect(() => {
    if (isHydrated) {
      dispatch(activateLocation(LOCATION.DISCOVERY));
    }
  }, [dispatch, isHydrated]);

  return (
    <div className="w-full h-full bg-white rounded-l-xl overflow-hidden">
      <MapProvider>
        <MedScoutMapsProvider>
          <ResultsListProvider>
            <DiscoveryMap />
          </ResultsListProvider>
        </MedScoutMapsProvider>
      </MapProvider>
    </div>
  );
};

export default Discovery;
